module.exports = __webpack_public_path__ + "img/icon-youtube.18a09044.svg";